import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { MenuItem } from '@ipfabric/ui-components/MenuItem/MenuItem';
import { date } from '@ipfabric/utils';
import type { FC, MouseEvent } from 'react';
import type { AppTranslations } from 'translations/translations';
import { SnapshotInfoTooltip } from './SnapshotInfoTooltip';
import type { ISnapshot } from './SnapshotTypes';
import { getSnapshotName } from './utils';

type Props = {
  snapshot: ISnapshot;
  selected: boolean;
  onSelect: (snapshotId: string, event: MouseEvent) => void;
  msg: AppTranslations['snapshotManagement'];
  dateTimeFormat: string;
  timezone: date.Timezone;
  defaultSnapshotName: string;
};

const isInvalidSnapshotStartTime = (tsStart?: number) =>
  tsStart === undefined || tsStart === 0;

export const SnapshotItem: FC<Props> = (props) => {
  if (!props.snapshot.id) {
    return null;
  }
  return (
    <MenuItem
      key={props.snapshot.id}
      description={
        isInvalidSnapshotStartTime(props.snapshot.tsStart)
          ? ''
          : date.formatUtcTimestampInTimeZone(
              props.snapshot.tsStart ?? 0,
              props.timezone,
              props.dateTimeFormat,
            )
      }
      selected={props.selected}
      trailingIcon={
        <div className='flex items-center'>
          {props.snapshot.state === 'unloaded' && (
            <span className='text-xs pr-3xs'>Unloaded</span>
          )}
          {props.snapshot.locked && (
            <Icon glyph='fa-lock' size='sm' className='text-icon-base' />
          )}
          {props.snapshot.running && (
            <Icon
              glyph='fa-spinner'
              className='text-icon-base animate-spin'
              size='sm'
            />
          )}
          {!['run', 'ready'].includes(props.snapshot.status ?? '') && (
            <SnapshotInfoTooltip snapshot={props.snapshot} msg={props.msg} />
          )}
        </div>
      }
      label={getSnapshotName(props.snapshot, props.defaultSnapshotName)}
      onClick={(e) => {
        props.onSelect(props.snapshot.id!, e);
      }}
    />
  );
};
